import { creditCards, creditCardActionType,SAVE_CREDIT_CARDS } from './types';

export function SaveCreditCards(creditCards: creditCards): creditCardActionType {
  return {
    type: SAVE_CREDIT_CARDS,
    payload: creditCards,
  };
}
